module.exports = __webpack_public_path__ + "img/icon.139e07d7.svg";